import axios from '@/axiosConnection'
import i18n from '@/traductions/config'
import toastr from '@/toastr'
import router from '@/Router'

export default {
  namespaced: true,
  state: {
    status: '',
    myImputations: (localStorage.getItem('myImputations') !== null ? localStorage.getItem('myImputations') : null),
    myTechs: (localStorage.getItem('myTechs') !== null ? localStorage.getItem('myTechs') : null),
    myFavoritesProducts: (localStorage.getItem('myFavoritesProducts') !== null ? localStorage.getItem('myFavoritesProducts') : null),
    user: (localStorage.getItem('user') !== null ? localStorage.getItem('user') : null),
    role: (localStorage.getItem('role') !== null ? localStorage.getItem('role') : ''),
    token: (localStorage.getItem('token') !== null ? localStorage.getItem('token') : null),
    authorizations: ''
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, token) {
      state.status = 'success'
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      state.token = token
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
    },
    setUser(state, user) {
      if (user) {
        state.user = user
      }
    },
    setMyTechs(state, myTechs) {
      if (myTechs) {
        state.myTechs = myTechs
      }
    },
    setMyImputations(state, myImputations) {
      if (myImputations) {
        state.myImputations = myImputations
      }
    },
    addProductToFavorites(state, idProduct){
      if (idProduct) {
        state.myFavoritesProducts.push(idProduct)
      }
    },
    removeFavoriteProductToCurrentUser(state, idProduct){
      if (idProduct) {
        state.myFavoritesProducts.unshift(idProduct)
      }
    },
    setMyFavoritesProducts(state, myFavoritesProducts) {
      if (myFavoritesProducts) {
        state.myFavoritesProducts = myFavoritesProducts
      }
    },
    authorize(state, authorizations) {
      state.authorizations = authorizations
    },
    setRole(state, role){
      state.role = role
    }
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    myTechs: state => state.myTechs,
    myImputations: state => state.myImputations,
    tech: state => id => state.myTechs.find(item => item.id == id),
    myFavoritesProducts: state => state.myFavoritesProducts,
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    isRole: state => role => state.role == role,
    role: state  => state.role,

    /**
     * Authorize if authorization's value is true (fast way) or if authorization's value is stored as true in authorizations_list
     */
     isAuthorized: (state, getters) => authorization => getters.isLoggedIn &&
      (((state.authorizations !== null && (state.authorizations[authorization] === null || state.authorizations[authorization] === true)) || authorization === true) || getters.role == 'ROLE_SUPER_ADMIN' || getters.role == 'ROLE_ADMIN'),
  },
  actions: {
    login(context, datas) {
      return new Promise((resolve, reject) => {
        context.commit('auth_request')

        // Api Request
        axios.post(`login`, {
          "email": datas.email,
          "password": datas.password
        }, {
          successHandle: false,
          errorHandle: false,
        }).then(response => {
          context.commit('showLoader', null, {root: true});

          const token = response.data.token

          // Token storage
          localStorage.setItem('token', token)

          context.commit('auth_success', token)
          resolve(response)

          context.dispatch('getCurrentUser')

        }).catch(error => {
          context.commit('auth_error')
          localStorage.removeItem('token')
          // toastr.error(i18n.t(error.response.data.status))

          // Too Many Attempts
          if (error.response.status === 307) {
            router.push({
              name: error.response.data.redirect
            })
          }

          reject(error)
        })
      })
    },
    logout({
      commit
    }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('token')
        delete axios.defaults.headers['Authorization']
        resolve()
      })
    },
    setRole: (context, role) => {
      context.commit('setRole', role)
    },
    addProductToFavorites(context, idProduct){
      context.commit('addProductToFavorites', idProduct)
    },
    removeFavoriteProductToCurrentUser(context, idProduct){
      context.commit('removeFavoriteProductToCurrentUser', idProduct)
    },
    getCurrentUser(context){
      return new Promise((resolve, reject) => {

        axios.get('user/current', {

        }).then(res => {

          context.commit('setUser', res.data)
          localStorage.setItem('user', JSON.stringify(res.data));

          context.commit('setRole', res.data.roles[0]);
          localStorage.setItem('role', res.data.roles[0]);
          //context.commit('hideLoader', null, {root: true});


          if(res.data.roles[0] == 'ROLE_AGENT'){
            context.dispatch('getMyTechs');
          }

          context.dispatch('getMyImputations')
          context.dispatch('getMyFavoritesProducts');

          resolve()

        }).catch(error => {
          reject()
        })

      })
    },
    getMyTechs(context){
      return new Promise((resolve, reject) => {

        axios.get('user/mytechnicians ', {

        }).then(r => {

          context.commit('setMyTechs', r.data.technicians)
          localStorage.setItem('myTechs', JSON.stringify(r.data.technicians));

          resolve()
        }).catch(error => {
          reject()
        })

      })
    },
    getMyImputations(context){
      return new Promise((resolve, reject) => {

        axios.get('agency/current ', {

        }).then(response => {

          context.commit('setMyImputations', response.data.imputations)
          localStorage.setItem('myImputations', JSON.stringify(response.data.imputations));

          resolve()
        }).catch(error => {
          reject()
        })

      })
    },
    getMyFavoritesProducts(context){
      return new Promise((resolve, reject) => {

        axios.get('product/favorite/current', {

        }).then(re => {

          context.commit('setMyFavoritesProducts', re.data)
          localStorage.setItem('myFavoritesProducts', JSON.stringify(re.data));

        }).catch(error => {
        })

      })
    },
    refreshAuthorizations({
      commit
    }) {
      // Call the profile page to retrieve current user's informations.
      if (this.getters.isLoggedIn) {
        axios.get('profile', {
          successHandle: false,
          errorHandle: false,
        }).then(response => {

          // Store current user's permissions
          let authorizations = response.data.authorization_list


          commit('authorize', authorizations)
        }).catch(error => {
          commit('logout')
        })
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/auth.js